import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentList20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDocumentList20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.5 17.5h-9a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.507v5.993H15.5V16.5a1 1 0 0 1-1 1m.826-10.507-3.82-3.778v3.778zM5.5 19h9a2.5 2.5 0 0 0 2.5-2.5V7.373a2 2 0 0 0-.594-1.422l-4.422-4.373A2 2 0 0 0 10.578 1H5.5A2.5 2.5 0 0 0 3 3.5v13A2.5 2.5 0 0 0 5.5 19m2.75-4.25A.75.75 0 0 1 9 14h4a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75M9 10.5A.75.75 0 0 0 9 12h4a.75.75 0 0 0 0-1.5zm-1.5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.75 4.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentList20);
